








import { Component, Prop, Watch, Vue } from 'vue-property-decorator'

@Component
export default class Empty extends Vue {
  private localVisible: boolean = false
  private totalAmount: string = ''
  mounted() {
    this.$emit('changeFooterConfig', {
      hasFooter: false,
      paddingBottom: 0
    })
  }
  goCollege() {
    this.$router.push({
      path: '/home_m/college'
    })
  }
}
